import React, { useState, useEffect, useMemo } from 'react'
import { Box, Button, Typography, Grid } from '@mui/material'
import StyledSwitch from '../common/StyledSwitch'
import { getClientName } from '../../api/premiumFeature.js'
import { sanitizeForLog } from '../../constants/index'
import CustomInput from '../Returns/CustomInput'

const AddGenAIForm = ({
  formData,
  handleFormSubmit,
  formErrors,
  isEdit,
  formLoading,
  onInputChange,
  setFormData,
}) => {
  const fetchClientData = async () => {
    try {
      const response = await getClientName()
      const clientDetails = response.data
      setFormData(prevFormData => ({
        ...prevFormData,
        clientName: clientDetails.clientName || clientDetails.clientUuid,
        clientUuid: clientDetails.clientUuid,
        enableGenAI: true
      }))
    } catch (error) {
      console.error('Error fetching client data:', sanitizeForLog(error?.message || 'Unknown error'))
    }
  }
  useEffect(() => {
    if (formData.uuid) return

    fetchClientData()
  }, [formData.uuid])


  return (
    <>
      {/* Mandatory fields note */}
      <Typography
        variant="body2"
        sx={{
          color: 'var(--forbrand-error)',
          mb: 4,
          fontSize: '14px',
        }}
      >
        (*) Fields are mandatory
      </Typography>

      {/* Form container */}
      <Box>
        <form onSubmit={handleFormSubmit}>
          <Box>
            <CustomInput
              label="Client Name"
              value={formData.clientName || ''}
              disabled
              error={!!formErrors.clientName}
              helperText={formErrors.clientName}
            />
          </Box>

          {/* SSO toggle */}
          <Grid
            item
            size={6}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              pt: '30px',
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: '16px',
                color: '#333333',
                fontWeight: 500,
              }}
            >
              Enable Gen AI
            </Typography>
            <StyledSwitch
              checked={!!formData.enableGenAI}
              onChange={e => onInputChange('enableGenAI', e.target.checked)}
            />
          </Grid>
          {formErrors.general && (
            <Typography variant="body2" color="error" sx={{ my: 1 }}>
              {formErrors.general}
            </Typography>
          )}
        </form>
      </Box>

      {/* Save button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingTop: '32px',
        }}
      >
        <Button
          type="submit"
          variant="contained"
          onClick={handleFormSubmit}
          disabled={formLoading || Object.keys(formErrors).length > 0}
          sx={{
            backgroundColor: 'var(--forbrand-bg-variant)',
            color: 'var(--forbrand-brand-varient)',
            textTransform: 'none',
            px: '17px',
            py: '8px',
            fontSize: '14px',
            '&:disabled': {
              backgroundColor: '#ccc',
            },
          }}
        >
          {formLoading ? 'Saving...' : isEdit ? 'Update' : 'Save'}
        </Button>
      </Box>
    </>
  )
}

export default AddGenAIForm
